import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonAiGenerateReq(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()
    const onClick = () => map.commands.aiGenerateReq(map.selectedNodes)

    return filterByLicense('M00040001',
        <MenuButton
            onClick={onClick}
            {...props}
        >
            AI编写需求
        </MenuButton>
    )
}
